import { render, staticRenderFns } from "./shelfTaskForm.vue?vue&type=template&id=23ae9f82&scoped=true&"
import script from "./shelfTaskForm.vue?vue&type=script&lang=js&"
export * from "./shelfTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./shelfTaskForm.vue?vue&type=style&index=0&id=23ae9f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae9f82",
  null
  
)

export default component.exports